import { UrlConstants } from "../url.constants";
export class ApiModuleNotificationTemplateConstants {
    static URL = UrlConstants.API_V2 + "ModuleNotificationTemplate";
}
